var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeopdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58991 7.08893C6.26447 7.41437 5.73683 7.41437 5.4114 7.08893L0.411396 2.08893C0.0859585 1.76349 0.0859585 1.23586 0.411396 0.910419C0.736833 0.584982 1.26447 0.584982 1.58991 0.910419L6.00065 5.32116L10.4114 0.910419C10.7368 0.584982 11.2645 0.584982 11.5899 0.910419C11.9153 1.23586 11.9153 1.76349 11.5899 2.08893L6.58991 7.08893Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeopdownIcon);
export default __webpack_public_path__ + "static/media/deopdownIcon.35f860f7c748e22adf7ac7c348401d13.svg";
export { ForwardRef as ReactComponent };